import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './api';

const Login = ({ setAuth }) => {
    const navigate = useNavigate();
    const [form, setForm] = useState({ username: "", password: "" });
    const [appType, setAppType] = useState("OFFICE"); 
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const res = await api.post('/auth/login', {
                username: form.username,
                password: form.password,
                appType: appType 
            });

            const { token, user } = res.data;
            sessionStorage.setItem('token', token);
            sessionStorage.setItem('user', JSON.stringify(user));
            setAuth(user);

            // --- NEW: DIRECT REDIRECT ---
            // If the user has a specific homepage set, go there.
            // Otherwise, go to default based on App Type.
            if (user.homepage && user.homepage !== '/') {
                 navigate(user.homepage);
            } else {
                 // Fallback defaults
                 if (appType === 'FACTORY') navigate('/labor');
                 else navigate('/');
            }

        } catch (err) {
            setError(err.response?.data?.message || "Login Failed");
        } finally {
            setLoading(false);
        }
    };

    // ... (Rest of your UI code remains exactly the same) ...
    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-dark">
            <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%' }}>
               {/* ... Keep existing UI ... */}
               <div className="text-center mb-4">
                    <span style={{ fontSize: '3rem' }}>💎</span>
                    <h3 className="fw-bold mt-2">DiamondSys ERP</h3>
                    <p className="text-muted small">Secure Access Portal</p>
                </div>

                <div className="d-flex mb-4 bg-light rounded p-1">
                    <button 
                        className={`btn w-50 fw-bold ${appType === 'OFFICE' ? 'btn-primary shadow-sm' : 'text-muted'}`}
                        onClick={() => setAppType('OFFICE')}
                    >
                        🏢 Office
                    </button>
                    <button 
                        className={`btn w-50 fw-bold ${appType === 'FACTORY' ? 'btn-warning text-dark shadow-sm' : 'text-muted'}`}
                        onClick={() => setAppType('FACTORY')}
                    >
                        🏭 Factory
                    </button>
                </div>

                {error && <div className="alert alert-danger text-center p-2 small">{error}</div>}

                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label fw-bold small">Username</label>
                        <input className="form-control" autoFocus value={form.username} onChange={e => setForm({...form, username: e.target.value})} required />
                    </div>
                    <div className="mb-4">
                        <label className="form-label fw-bold small">Password</label>
                        <input type="password" className="form-control" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
                    </div>

                    <button disabled={loading} className={`btn w-100 fw-bold py-2 ${appType === 'OFFICE' ? 'btn-primary' : 'btn-warning'}`}>
                        {loading ? 'Verifying...' : '🔐 Login'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;